import { IBusinessNumberModel, IIncomingCallSettings, IOutgoingCallSettings } from "src/types/models/apiModels";
import { TBrandingOptions } from "src/types/models/common";

export interface IBrandingApplication {
    name: string;
    businessId: string;
    mobileApplicationId: string;
    contactCenterId?: string;
    description?: string;
    brandingOption: TBrandingOptions
    outgoingCallSettings: IOutgoingCallSettings
    incomingCallSetting?: IIncomingCallSettings
    brandingNumber: IBusinessNumberModel
}

export enum CPaaSProvider {
    Vonage = "Vonage"
}